import { takeLatest, put } from 'redux-saga/effects';

import {
    CANCEL_UNIDADE_MEDIDA_CADASTRO_RAPIDO,
    CANCEL_UNIDADE_MEDIDA_CADASTRO_RAPIDO_SUCCESS
} from '../actionTypes';

function* sagaCancelUnidadeMedidaCadastroRapido() {
  yield put({ type: CANCEL_UNIDADE_MEDIDA_CADASTRO_RAPIDO_SUCCESS})
}

export default function* watchCancelUnidadeMedidaCadastroRapido() {
  yield takeLatest(CANCEL_UNIDADE_MEDIDA_CADASTRO_RAPIDO, sagaCancelUnidadeMedidaCadastroRapido)
}